
import { useState } from "react";
import { CalendarEvent } from "@/hooks/calendar/types";
import { TimeSlot, TimeSlotDialogState } from "./types";

export const useTimeSlotDialogs = () => {
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<TimeSlot | null>(null);
  const [isBookingDialogOpen, setIsBookingDialogOpen] = useState(false);
  const [isClientRequestDialogOpen, setIsClientRequestDialogOpen] = useState(false);
  const [isConflictDialogOpen, setIsConflictDialogOpen] = useState(false);
  const [isPastTimeSlotDialogOpen, setIsPastTimeSlotDialogOpen] = useState(false);
  const [conflictingEvents, setConflictingEvents] = useState<CalendarEvent[]>([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [eventToDelete, setEventToDelete] = useState<CalendarEvent | null>(null);

  const dialogState: TimeSlotDialogState = {
    isBookingDialogOpen,
    isClientRequestDialogOpen,
    isConflictDialogOpen,
    isPastTimeSlotDialogOpen,
    deleteDialogOpen
  };

  return {
    selectedTimeSlot,
    setSelectedTimeSlot,
    conflictingEvents,
    setConflictingEvents,
    eventToDelete,
    setEventToDelete,
    dialogState,
    setIsBookingDialogOpen,
    setIsClientRequestDialogOpen,
    setIsConflictDialogOpen,
    setIsPastTimeSlotDialogOpen,
    setDeleteDialogOpen
  };
};
